const timeReload = () => {
  setTimeout(() => {
    window.location.href = '/'
  }, 2000)
}

export default timeReload
